module.exports = __webpack_public_path__ + "img/tasks.8b271f1f.svg";